import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'overviewSubjectName',
})
export class OverviewSubjectNamePipe implements PipeTransform {
  public transform(subject: string | null | undefined): string {
    return String(subject).replace('[KB] ', '').replace('KB ', '');
  }
}
